import React from 'react';
import './featureContent.css';

/**
 * Example / receipt-style summary card.
 * @param {string} title
 * @param {string} meta - small subtitle/meta line (e.g. "📸 3 photos")
 * @param {{ sectionTitle?: string, rows: {label: string, value: string}[] }[]} groups
 * @param {{label: string, value: string}} total
 * @param {React.ReactNode} cta
 */
function FeatureExampleCard({ title, meta, groups, total, cta }) {
    return (
        <div className="fc-example-card">
            <div className="fc-example-title">{title}</div>
            {meta && <div className="fc-example-meta">{meta}</div>}
            {groups.map((group, groupIndex) => (
                <div key={group.sectionTitle || groupIndex}>
                    {groupIndex > 0 && <div className="fc-example-divider" />}
                    {group.sectionTitle && <div className="fc-example-section-title">{group.sectionTitle}</div>}
                    {group.rows.map((row) => (
                        <div className="fc-example-row" key={row.label}>
                            <span>{row.label}</span>
                            <span>{row.value}</span>
                        </div>
                    ))}
                </div>
            ))}
            <div className="fc-example-total-row">
                <span className="fc-example-total-label">{total.label}</span>
                <span className="fc-example-total-value">{total.value}</span>
            </div>
            {cta && <div className="fc-example-cta">{cta}</div>}
        </div>
    );
}

export default FeatureExampleCard;
